import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

class followMenu {
  static menu = document.getElementsByClassName("js__follow-menu")[0];
  static endTriggerElement = document.getElementById("js__sidemenu-container");
  static instanceList = [];
  static headerHeight = 0;

  static init = () => {
    if (!followMenu.menu || !followMenu.endTriggerElement) return;

    followMenu.initializeScrollTrigger();

    // 画面サイズが変更された際にヘッダーの高さを更新する
    window.addEventListener('resize', followMenu.updateHeaderHeight);
  }

  static initializeScrollTrigger = () => {
    let mm = gsap.matchMedia();
    mm.add("(min-width: 1000px)", () => {
      followMenu.instanceList.push(ScrollTrigger.create({
        trigger: followMenu.menu,
        start: "top top",
        endTrigger: followMenu.endTriggerElement,
        end: "bottom top",
        markers: false,
        pin: true,
        scrub: true,
        onEnter: () => {
          followMenu.updateHeaderHeight(); // ヘッダーの高さを更新
        },
        onLeaveBack: () => {
          followMenu.updateHeaderHeight(); // ヘッダーの高さを更新
        },
        onUpdate: (self) => {
          if (self.isActive) {
            // PCサイズの処理
            if (self.direction > 0) {
              gsap.to(followMenu.menu, {
                duration: 0,
                y: 0,
                ease: "none",
                overwrite: true
              });
            } else {
              gsap.to(followMenu.menu, {
                duration: 0,
                y: followMenu.headerHeight,
                ease: "none",
                overwrite: true
              });
            }
          }
        },
      }));
    });
  }

  static updateHeaderHeight = () => {
    const header = document.querySelector('.l-header');
    if (header) {
      followMenu.headerHeight = header.offsetHeight;
    }
  }

  static refresh = () => {

    followMenu.instanceList.forEach(instance => {
      instance.kill();  // ScrollTriggerインスタンスをkill
    });

    followMenu.instanceList = [];  // インスタンスリストをクリア

    followMenu.initializeScrollTrigger();  // ScrollTriggerの設定を再初期化
  }

  static destroy = () => {
    followMenu.instanceList.forEach(instance => instance.kill());
    followMenu.instanceList = [];
  }

  static rebuild = () => {
    this.destroy();
    this.init();
  }
}

export default followMenu;
